import { render, staticRenderFns } from "./InventoryNavi.vue?vue&type=template&id=6042dd14&scoped=true"
import script from "./InventoryNavi.vue?vue&type=script&lang=js"
export * from "./InventoryNavi.vue?vue&type=script&lang=js"
import style0 from "./InventoryNavi.vue?vue&type=style&index=0&id=6042dd14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6042dd14",
  null
  
)

export default component.exports